import React, { useEffect, useState } from "react"
import styled, { css } from "styled-components"
import { useStaticQuery, graphql } from "gatsby"
import HeroImage from "../HeroImage"

import sleep from "../../utils/sleep"

const Placeholder = ({ containerStyle, serverSide }) => {
  const [timeOut, setTimeOut] = useState(null)
  useEffect(() => {
    waitTimer()
  }, [])
  const waitTimer = async () => {
    await sleep(3000)
    setTimeOut(true)
  }

  const { map_placeholder } = usePlaceholderQuery()

  return (
    <>
      <Container
        timeout={timeOut}
        style={containerStyle}
        serverSide={serverSide}
      >
        <HeroImage bg={map_placeholder.url} />
      </Container>
    </>
  )
}

export default Placeholder

const Container = styled.div`
  ${props =>
    props.timeout &&
    css`
      opacity: 0;
      pointer-events: none;
    `}
  ${props =>
    props.serverSide &&
    css`
      position: relative;
    `}
  top: 0;
  left: 0;
  bottom: 0;
  position: absolute;
  right: 0;
  transition: opacity ease 300ms;
  z-index: 11;
`

const usePlaceholderQuery = () => {
  const { wordsbyData } = useStaticQuery(
    graphql`
      {
        wordsbyData {
          map_placeholder {
            url {
              childImageSharp {
                fluid(
                  quality: 90
                  maxWidth: 1440
                  traceSVG: {
                    color: "#88AFCB"
                    turdSize: 1000
                    optTolerance: 0.1
                    alphaMax: 0.1
                  }
                ) {
                  ...GatsbyImageSharpFluid_withWebp_tracedSVG
                }
              }
            }
          }
        }
      }
    `
  )

  const data = { ...wordsbyData }
  return data
}
